import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SDM18HCL from './SDM18HCL';
import BasicForm from './BasicForm';

class HeatAndCoolDetail extends PureComponent {
    static propTypes = {
        moduleType: PropTypes.string.isRequired
    };

    static defaultProps = {};

    render() {
        const { moduleType } = this.props;

        const detailContentByType = {
            SDM18HCL: () => <SDM18HCL {...this.props} />,
            default: () => null
        };
        return <BasicForm {...this.props}>{(detailContentByType[moduleType] || detailContentByType['default'])()}</BasicForm>;
    }
}
export default HeatAndCoolDetail;



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/HeatAndCool/index.js